import {
    RelatorioResultadoContatoExportExcelService,
    RelatorioResultadoContatoService,
} from "../../../Services/Cobranca/Relatorios/RelatoriosServices";
import { ResultadoContatoRequest } from "../../../Interfaces/Relatorios/RelatoriosInterface";
import { Controller } from "../../Controller";

export async function RelatorioResultadoContatoController(
    ResultadoContato: ResultadoContatoRequest
) {
    return Controller(RelatorioResultadoContatoService(ResultadoContato));
}

export async function RelatorioResultadoContatoExportExcelController(
    flExport: boolean,
    ResultadoContato: ResultadoContatoRequest
) {
    return Controller(
        RelatorioResultadoContatoExportExcelService(flExport, ResultadoContato)
    );
}
